import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, UsersIcon, CalculatorIcon, ClipboardListIcon, BriefcaseIcon, FileTextIcon, BanIcon, BarChart3Icon, NetworkIcon, SettingsIcon, ChevronDownIcon } from 'lucide-react';
interface MenuItem {
  icon: any;
  label: string;
  href?: string;
  subItems?: {
    label: string;
    href: string;
  }[];
}
const menuItems: MenuItem[] = [{
  icon: HomeIcon,
  label: 'Dashboard / Inicio',
  href: '/dashboard'
}, {
  icon: UsersIcon,
  label: 'Gestión de Usuarios',
  subItems: [{
    label: 'Usuarios y Roles',
    href: '/users'
  }, {
    label: 'Usuarios BackOffice',
    href: '/backoffice-users'
  }, {
    label: 'Brigadas/Gestores',
    href: '/field-users'
  }, {
    label: 'Usuarios Potenciales',
    href: '/potential-users'
  }]
}, {
  icon: CalculatorIcon,
  label: 'Simulador Financiero',
  href: '/financial-simulator'
}, {
  icon: ClipboardListIcon,
  label: 'Planes y Estrategias',
  subItems: [{
    label: 'Estrategias Comerciales',
    href: '/commercial-strategy'
  }, {
    label: 'Planes de Financiación',
    href: '/financial-plans'
  }]
}, {
  icon: BriefcaseIcon,
  label: 'Aliados y Contratistas',
  href: '/contractors'
}, {
  icon: FileTextIcon,
  label: 'Documentos',
  href: '/documents'
}, {
  icon: BanIcon,
  label: 'Desistimientos',
  href: '/withdrawal-forms'
}, {
  icon: BarChart3Icon,
  label: 'Reportes e Informes',
  href: '/reports'
}, {
  icon: NetworkIcon,
  label: 'Integraciones',
  href: '/integrations'
}, {
  icon: SettingsIcon,
  label: 'Configuración',
  href: '/settings'
}];
export const Sidebar = () => {
  const [expandedItems, setExpandedItems] = useState<string[]>([]);
  const location = useLocation();
  const toggleExpand = (label: string) => {
    setExpandedItems(prev => prev.includes(label) ? prev.filter(item => item !== label) : [...prev, label]);
  };
  const isActive = (href: string) => location.pathname === href;
  return <aside className="fixed left-0 top-16 bottom-0 w-64 bg-white border-r border-gray-200 z-40 overflow-y-auto" data-id="element-527">
      <nav className="p-4" data-id="element-528">
        <ul className="space-y-1" data-id="element-529">
          {menuItems.map(item => <li key={item.label} data-id="element-530">
              {item.subItems ? <div className="space-y-1" data-id="element-531">
                  <button onClick={() => toggleExpand(item.label)} className="w-full text-left flex items-center justify-between px-4 py-3 text-gray-600 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-532">
                    <div className="flex items-center gap-3" data-id="element-533">
                      <item.icon className="h-5 w-5 flex-shrink-0" data-id="element-534" />
                      <span className="font-medium" data-id="element-535">{item.label}</span>
                    </div>
                    <ChevronDownIcon className={`h-4 w-4 flex-shrink-0 transition-transform ${expandedItems.includes(item.label) ? 'transform rotate-180' : ''}`} data-id="element-536" />
                  </button>
                  {expandedItems.includes(item.label) && <ul className="pl-4 space-y-1" data-id="element-537">
                      {item.subItems.map(subItem => <li key={subItem.label} data-id="element-538">
                          <Link to={subItem.href} className={`flex items-center px-4 py-2 text-sm ${isActive(subItem.href) ? 'text-blue-600 bg-blue-50' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'} rounded-lg transition-colors`} data-id="element-539">
                            <span className="ml-8" data-id="element-540">{subItem.label}</span>
                          </Link>
                        </li>)}
                    </ul>}
                </div> : <Link to={item.href} className={`flex items-center gap-3 px-4 py-3 ${isActive(item.href) ? 'text-blue-600 bg-blue-50' : 'text-gray-600 hover:bg-gray-50'} rounded-lg transition-colors`} data-id="element-541">
                  <item.icon className="h-5 w-5 flex-shrink-0" data-id="element-542" />
                  <span className="font-medium" data-id="element-543">{item.label}</span>
                </Link>}
            </li>)}
        </ul>
      </nav>
    </aside>;
};